module.exports = __webpack_public_path__ + "static/media/404.bad33fe0.png";